"use client";
import React from "react";
import {
  Box,
  Center,
  Separator,
  Table,
  VStack,
  Text,
  HStack,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";
import { IP_PRICING_DATA, FOOTER_CONSTANTS } from "./constants";

export const DesktopView = () => (
  <Table.Root striped border="2px solid rgb(237,242,247)" width="100%">
    <Table.Header>
      <Table.Row>
        <Table.ColumnHeader textAlign="center">Name</Table.ColumnHeader>
        <Table.ColumnHeader textAlign="center">Count</Table.ColumnHeader>
        <Table.ColumnHeader textAlign="center">Price per IP / Hour</Table.ColumnHeader>
        <Table.ColumnHeader textAlign="center">Price per IP / Month</Table.ColumnHeader>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {IP_PRICING_DATA.map((plan, index) => (
        <Table.Row key={index}>
          <Table.Cell textAlign="center">{plan.name}</Table.Cell>
          <Table.Cell textAlign="center">{plan.count}</Table.Cell>
          <Table.Cell
            textAlign="center"
            color={plan.pricePerHour === "FREE" ? "green.500" : "primary.200"}
            fontWeight="bold"
          >
            {plan.pricePerHour}
          </Table.Cell>
          <Table.Cell
            textAlign="center"
            color={plan.pricePerMonth === "FREE" ? "green.500" : "primary.200"}
            fontWeight="bold"
          >
            {plan.pricePerMonth}
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Root>
);

export const MobileView = () => (
  <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
    {IP_PRICING_DATA.map((plan, index) => (
      <VStack
        key={index}
        borderRadius="lg"
        borderWidth="1px"
        borderColor="gray.200"
        boxShadow="md"
        gap={4}
        w="100%"
        p={4}
        bg="white"
      >
        <Flex direction="column" w="full">
          <Text fontWeight="bold" fontSize="lg">
            {plan.name}
          </Text>
        </Flex>

        <Separator borderColor="gray.200" />

        <HStack w="full" justify="space-between">
          <Text fontSize="sm" color="text.100">
            Count
          </Text>
          <Text fontWeight="medium">{plan.count}</Text>
        </HStack>

        <HStack w="full" justify="space-between">
          <Text fontSize="sm" color="text.100">
            Price / Hour
          </Text>
          <Text
            fontWeight="bold"
            color={plan.pricePerHour === "FREE" ? "green.500" : "primary.200"}
          >
            {plan.pricePerHour}
          </Text>
        </HStack>

        <HStack w="full" justify="space-between">
          <Text fontSize="sm" color="text.100">
            Price / Month
          </Text>
          <Text
            fontWeight="bold"
            color={plan.pricePerMonth === "FREE" ? "green.500" : "primary.200"}
          >
            {plan.pricePerMonth}
          </Text>
        </HStack>
      </VStack>
    ))}
  </SimpleGrid>
);

const IpPricingTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="ipv4/v6">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        Public IP Pricing
      </Heading>
      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
      <PricingFooter {...FOOTER_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default IpPricingTable;
